<ng-container *transloco="let t; read: 'expenseTypes'">
  <h2 class="mbm">{{ t('title') }}</h2>
<kendo-grid
  [data]="expenseTypes"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>

  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="type" [title]="t('type')">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ t('kind.' + kindName(dataItem.type)) }}
    </ng-template>
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-dropdownlist
        [data]="kindOptions"
        [textField]="'text'"
        [valueField]="'value'"
        [valuePrimitive]="true"
        [formControl]="formGroup.get('type')">
        <ng-template kendoDropDownListItemTemplate let-dataItem>
          {{ t('kind.' + dataItem.text) }}
        </ng-template>
        <ng-template kendoDropDownListValueTemplate let-dataItem>
          {{ t('kind.' + dataItem.text) }}
        </ng-template>
      </kendo-dropdownlist>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="kmRate" [title]="t('kmRate')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-numerictextbox [decimals]="2" [format]="'n2'" [min]="0"
        [formControl]="formGroup.get('kmRate')"></kendo-numerictextbox>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="flatrate" [title]="t('flatrate')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-numerictextbox [decimals]="2" [format]="'n2'" [min]="0"
        [formControl]="formGroup.get('flatrate')"></kendo-numerictextbox>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="salaryPayment" [title]="t('salaryPayment')" editor="boolean">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.salaryPayment ? t('yes') : t('no') }}
    </ng-template>
    <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
      <input
        type="checkbox"
        kendoCheckBox
        [value]="dataItem.salaryPayment"
        [formControl]="formGroup.get('salaryPayment')"
      />
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="requiresReceipt" [title]="t('requiresReceipt')" editor="boolean">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.requiresReceipt ? t('yes') : t('no') }}
    </ng-template>
    <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup">
      <input
        type="checkbox"
        kendoCheckBox
        [value]="dataItem.requiresReceipt"
        [formControl]="formGroup.get('requiresReceipt')"
      />
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column [title]="t('action')">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button kendoGridRemoveCommand>{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessage')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
